import styled, { RuleSet } from 'styled-components'

export interface TypographyProps {
  $style?: RuleSet<object>
  $fontStyle?: RuleSet<object>
  $color?: string
}

export const Typography = styled.span<TypographyProps>`
  ${(props) => props.$style};
  ${(props) => props.$fontStyle};
  color: ${(props) => props.$color};
`
